import httpMethod from 'services/update2025/httpMethod';
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { RequestLookupContext } from "./RequestLookupContext";

export const RequestLookupTraCuu = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["request-lookup", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const requestLookupContext = useContext(RequestLookupContext);
    const { requestLookupDialog, setRequestLookupDialog, requestLookupData, setRequestLookupData } = requestLookupContext;

    const hideDialog = () => {
        setRequestLookupDialog(false);
    };

    const parseObj = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map((e, i) => {
                return parseObj(e);
            });
        } else if (typeof obj === "object" && obj !== null && obj !== undefined) {
            return Object.keys(obj).map((k, i) => {
                if (Array.isArray(obj[k])) {
                    return parseObj(obj[k]);
                }
                return (
                    <div className="col-12" key={i}>
                        <b>{k}</b>: {obj[k]}
                    </div>
                );
            });
        }
        return <div className="col-12">{obj}</div>;
    };

    return (
        <Dialog visible={requestLookupDialog} style={{ width: "40%" }} header={t("request-lookup.titleDetail")?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
            <div className="formgrid">
                <div className="grid text-left mt-2">
                    <div className="col-12">
                        <div className="grid">{parseObj(requestLookupData)}</div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
